<app-hero-title [size]="'medium'">
  <span highlight>Congratulations!<br></span>
  <span after class="dark">
    You have successfully registered for the event!
  </span>
</app-hero-title>
<p class="mt-3 mb-4 pb-3 col-gray-500">Check your <span class="semi-bold">john.doe@somefancyemail.com</span> mailbox, we have sent you the confirmation!</p>
<app-button [submit]="true">Download Invoice</app-button>
